{
    "InsightsDashboard_Title": "Approfondimenti",
    "InsightsDashboard_BusinessFilter": "Filtro aziendale",
    "InsightsDashboard_AllPartitions": "Tutti i siti",
    "InsightsDashboard_CallsReceived": "Chiamate ricevute",
    "InsightsDashboard_MissedCalls": "Chiamate perse",
    "InsightsDashboard_AverageAnswer": "Risposta media",
    "InsightsDashboard_AverageAbandoned": "Abbandonato medio",
    "InsightsDashboard_LongestWait": "L'attesa più lunga",
    "InsightsDashboard_VsLastWeekCurrently": "Attualmente",
    "InsightsDashboard_PercentVsLastWeek": "**{}%** rispetto alla settimana scorsa",
    "InsightsDashboard_VsLastWeek": "**{}** rispetto alla settimana scorsa",
    "InsightsDashboard_BusiestDay": "Giorno più trafficato",
    "InsightsDashboard_PeakCalls": "Chiamate di punta",
    "InsightsDashboard_MostCalledInboundNumber": "Numero in entrata più chiamato",
    "InsightsDashboard_MostAnsweredCalls": "Chiamate più risposte",
    "InsightDashboard_CalledNumber": "Numero chiamato",
    "InsightsDashboard_User": "Utente",
    "InsightsDashboard_SecondsDisplay": "{}S",
    "InsightsDashboard_Tooltip_TimeLabel": "Ora: {}:00",
    "InsightsDashboard_Tooltip_DayLabel": "Giorno: {}",
    "InsightsDashboard_Tooltip_CallsLabel": "Numero di chiamate: {}",
    "InsightsDashboard_Tooltip_Stats_0": "Chiamate ricevute: {}",
    "InsightsDashboard_Tooltip_Stats_1": "Chiamate perse: {}",
    "InsightsDashboard_Tooltip_Stats_2": "Risposta media: {}",
    "InsightsDashboard_Tooltip_Stats_3": "Abbandonati medi: {}",
    "InsightsDashboard_Tooltip_Stats_4": "Attesa più lunga: {}",
    "InsightsDashboard_Tooltip_Stats_WeekCommencing": "Settimana a partire dal: {}",
    "InsightsDashboard_OfLast30Days": "degli ultimi 30 giorni",
    "InsightsDashboard_OverLast30Days": "Negli ultimi 30 giorni",
    "InsightsDashboard_OverLast7Days": "Negli ultimi 7 giorni",
    "InsightsDashboard_ThisWeek": "Questa settimana",
    "InsightsDashboard_LastWeek": "La settimana scorsa",
    "InsightsDashboard_PrevWeek": "Settimana precedente",
    "InsightsDashboard_ErrorState_Message": "Ci scusiamo per il problema. \n Aggiorna il browser. \n \n {}",
    "InsightsDashboard_ErrorState_No_TelSys_Or_Partition": "Nessun server di telefonia o partizione selezionata",
    "InsightsDashboard_Tour_Step_1": "Qui selezioni la tua attività e il tuo sito",
    "InsightsDashboard_Tour_Step_2": "Visualizza le metriche dei punti di contatto della tua attività negli ultimi 30 giorni: \n ##?##Giorni più impegnativi, che ti consentono di pianificare meglio le risorse####Orari più impegnativi, sii pronto con una copertura negli orari di punta per non perdere chiamate####?",
    "InsightsDashboard_Tour_Step_3": "Metriche chiave sulle prestazioni delle chiamate negli ultimi 30 giorni: \n ##?##Numero totale di chiamate ricevute dalla tua azienda####Chiamate perse####Tempi medi di risposta e di abbandono####Tempo massimo di attesa di una chiamata####? \n Fai clic sulle metriche per ottenere un confronto e tendenze settimanali.",
    "InsightsDashboard_Tour_Step_4": "Identifica le chiamate DDI in entrata effettuate più frequentemente negli ultimi 7 giorni e quali utenti rispondono al maggior numero di chiamate. Verranno visualizzate le prime 10.",
    "InsightsDashboard_Tour_Step_5": "Clicca qui per aprire il portale di segnalazione",
    "InsightsDashboard_Tour_Step_6": "Clicca qui per aprire il portale di segnalazione",
    "NAME": "InsightsDashboardLanguage"
}